import React from 'react';
import { motion } from 'framer-motion';
const antes = [{
  bold: 'Te acostatás cansada',
  light: 'y aun así no descansatás.'
}, {
  bold: 'A media tarde necesitás',
  light: 'azúcar o café para seguir.'
}, {
  bold: 'Tu ropa ya no',
  light: 'se siente igual.'
}, {
  bold: 'Sentís que tu cuerpo cambió,',
  light: 'pero no entenés por qué.'
}];
const despues = [{
  bold: 'Empezás a distinguir',
  light: 'qué te está pidiendo tu cuerpo, en vez de adivinar.'
}, {
  bold: 'Encontrás hábitos que podés sostener,',
  light: 'no otro esfuerzo más.'
}, {
  bold: 'Volvés a leer tus propias señales',
  light: 'antes de que se acumulen.'
}, {
  bold: 'Tenés un sistema,',
  light: 'no otra dieta que abandonar.'
}];
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 8
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.09,
      ease: 'easeOut'
    }
  })
};
export function DifferenceSection() {
  return <section className="bg-gradient-section py-24 md:py-32 px-5 md:px-8" style={{
    paddingBottom: "0px"
  }} data-id="element-41" data-mp="2frnmfkm31lm7">
      <div className="max-w-2xl mx-auto" data-id="element-42" data-mp="2kqgxz7ht72jq">

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center uppercase tracking-[0.28em] text-[#C8A870] mb-5" style={{
        fontSize: 11,
        fontFamily: 'sans-serif',
        fontWeight: 600
      }} data-id="element-43" data-mp="2krjsrqi95p4x">
          La diferencia después de 21 días
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="text-center font-display font-semibold text-[#F0E8D8] leading-[1.05] mb-16 md:mb-20" style={{
        fontSize: 'clamp(34px, 7vw, 58px)'
      }} data-id="element-44" data-mp="33obfyb0x0oe9">
          Del agotamiento{' '}
          <span className="italic text-gradient-gold" data-id="element-45" data-mp="3mgvwqu3cb31p">a la estrategia.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-[1fr_auto_1fr] gap-0" data-id="element-46" data-mp="1memjmxl3ykej">
          {/* Columna ANTES */}
          <div data-id="element-47" data-mp="1rcfnhjyxv2bn">
            <p className="uppercase tracking-[0.22em] text-[#F0E8D8]/30 mb-4 pb-3" style={{
            fontSize: 10,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            borderBottom: '0.5px solid rgba(240,232,216,0.1)'
          }} data-id="element-48" data-mp="1rbwhn1mkc4dz">
              Antes
            </p>
            <motion.ul initial="hidden" whileInView="visible" viewport={{
            once: true,
            amount: 0.2
          }} className="space-y-9" data-id="element-49" data-mp="2f2s5xort8hgh">
              {antes.map((item, i) => <motion.li key={i} custom={i} variants={itemVariants} className="flex gap-2.5" data-id="element-50" data-mp="kohct446n14w" data-mpi={i}>
                  <span className="flex-shrink-0 text-[#C8A870]/50 mt-0.5 select-none" style={{
                fontSize: 14,
                lineHeight: 1.5,
                fontFamily: 'sans-serif'
              }} data-id="element-51" data-mp="fpecfwz5dj39">—</span>
                  <div data-id="element-52" data-mp="2wcdv6wx6rl5c">
                    <p className="font-body text-[#F0E8D8]/45 leading-[1.5]" style={{
                  fontSize: 'clamp(12px, 2.2vw, 14px)'
                }} data-id="element-53" data-mp="2wajb1ktqnx2b">
                      <strong className="font-semibold text-[#F0E8D8]/55" data-id="element-54" data-mp="2mlrnrpzmi0xq">{item.bold}</strong>
                      <br data-id="element-55" data-mp="28m9vv1r167k5" />{item.light}
                    </p>
                  </div>
                </motion.li>)}
            </motion.ul>
          </div>

          {/* Divisor central */}
          <div className="flex flex-col items-center" style={{
          width: 56,
          paddingTop: 32
        }} data-id="element-56" data-mp="2dj09lifd4r2e">
            <div className="flex-1 w-px" style={{
            background: 'linear-gradient(to bottom, transparent, rgba(200,168,112,0.3))',
            minHeight: 48
          }} data-id="element-57" data-mp="23n6w9wttktjk" />
            <div className="flex-shrink-0 flex flex-col items-center justify-center rounded-full" style={{
            width: 48,
            height: 48,
            border: '1px solid rgba(200,168,112,0.35)',
            background: 'rgba(200,168,112,0.05)'
          }} data-id="element-58" data-mp="3t00o4kv1wle1">
              <span className="text-[#C8A870] leading-none" style={{
              fontSize: 14,
              fontFamily: 'sans-serif',
              fontWeight: 700
            }} data-id="element-59" data-mp="1tyohvp6111pj">21</span>
              <span className="text-[#C8A870] uppercase leading-none tracking-[0.08em]" style={{
              fontSize: 7,
              fontFamily: 'sans-serif',
              fontWeight: 600,
              marginTop: 1
            }} data-id="element-60" data-mp="1jzywhmex8z4j">días</span>
            </div>
            <div className="flex-1 w-px" style={{
            background: 'linear-gradient(to bottom, rgba(200,168,112,0.3), transparent)',
            minHeight: 48
          }} data-id="element-61" data-mp="1a7jg2tj9wilr" />
          </div>

          {/* Columna DESPUÉS */}
          <div data-id="element-62" data-mp="w9bnext9s3ge">
            <p className="uppercase tracking-[0.22em] text-[#C8A870] mb-4 pb-3" style={{
            fontSize: 10,
            fontFamily: 'sans-serif',
            fontWeight: 600,
            borderBottom: '0.5px solid rgba(200,168,112,0.2)'
          }} data-id="element-63" data-mp="w9uwdp0xzhia">
              Después
            </p>
            <motion.ul initial="hidden" whileInView="visible" viewport={{
            once: true,
            amount: 0.2
          }} className="space-y-9" data-id="element-64" data-mp="m550o0w4t9mi">
              {despues.map((item, i) => <motion.li key={i} custom={i} variants={itemVariants} className="flex gap-2.5" data-id="element-65" data-mp="w3u80zqejboi" data-mpi={i}>
                  <span className="flex-shrink-0 text-[#C8A870] mt-0.5 select-none" style={{
                fontSize: 14,
                lineHeight: 1.5,
                fontFamily: 'sans-serif'
              }} data-id="element-66" data-mp="w1hqgnok33bz">—</span>
                  <div data-id="element-67" data-mp="8ejea27gyhjv">
                    <p className="font-body text-[#F0E8D8]/85 leading-[1.5]" style={{
                  fontSize: 'clamp(12px, 2.2vw, 14px)'
                }} data-id="element-68" data-mp="8d8cg7xl3jve">
                      <strong className="font-semibold text-[#F0E8D8]" data-id="element-69" data-mp="d6syr2pteper">{item.bold}</strong>
                      <br data-id="element-70" data-mp="3bt5o6lbe8zvu" />{item.light}
                    </p>
                  </div>
                </motion.li>)}
            </motion.ul>
          </div>
        </motion.div>

        {/* Transición de identidad */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="mt-20 md:mt-28 max-w-md mx-auto text-center" data-id="element-71" data-mp="33uaeew4q0hps">
          {/* Ajuste 1: opacidad subida de /40 a /65 para legibilidad en móvil con brillo bajo */}
          <p className="font-display italic text-[#F0E8D8]/65 leading-[1.5]" style={{
          fontSize: 'clamp(16px, 3.2vw, 21px)'
        }} data-id="element-72" data-mp="2pwcegvr5cntt">
            “Lo que antes funcionaba,<br data-id="element-73" data-mp="2zua33kcx4mmy" />hoy ya no alcanza.”
          </p>

          <div className="flex flex-col items-center my-7 gap-0.5" data-id="element-74" data-mp="2utvqrq4aaqj4">
            <div className="w-px" style={{
            height: 28,
            background: 'linear-gradient(to bottom, rgba(200,168,112,0.15), rgba(200,168,112,0.55))'
          }} data-id="element-75" data-mp="2uvp39m1kw4z1" />
            <span className="text-[#C8A870]" style={{
            fontSize: 18,
            lineHeight: 1
          }} data-id="element-76" data-mp="a2vb9m5fmd3j">↓</span>
          </div>

          <p className="font-display font-semibold text-[#F0E8D8] leading-[1.2] mb-4" style={{
          fontSize: 'clamp(24px, 5.5vw, 36px)'
        }} data-id="element-77" data-mp="mlzbxk1ml3e6">
            No se trata de volver atrás.
          </p>
          <p className="font-display italic text-gradient-gold leading-[1.25]" style={{
          fontSize: 'clamp(20px, 5vw, 32px)'
        }} data-id="element-78" data-mp="cntdjcf12fe2">
            Se trata de aprender<br data-id="element-79" data-mp="10e5sh78oxce5" />qué necesita tu cuerpo hoy.
          </p>

          <div className="mx-auto mt-10 mb-7" style={{
          width: 48,
          height: '0.5px',
          background: 'rgba(200,168,112,0.35)'
        }} data-id="element-80" data-mp="15cqheaihs9na" />

          
        </motion.div>

      </div>
    </section>;
}